import { LRUCache } from "./LRUCache";

export const classesPageCache = new LRUCache({
  max: 100,
});
export const groupsPageCache = new LRUCache({
  max: 100,
});
export const featureGroupsPageCache = new LRUCache({
  max: 100,
});
export const featuresPageCache = new LRUCache({
  max: 100,
});
export const unitsPageCache = new LRUCache({
  max: 100,
});
export const valuesPageCache = new LRUCache({
  max: 100,
});
export const includedFeaturePageCache = new LRUCache({
  max: 100,
});
